<template>
  <div class="voice" @click="toggle">
    <div :class="['process', { 'play': isPlay }]" :style="{width: process + '%'}"></div>
    <div class="icon" :style="{backgroundPosition: position + 'px 0'}"></div>
    <audio ref="audio" :src="src"></audio>
    <div class="timer">{{ time }}</div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    isPause: {
      type: Boolean,
      default: false
    },
    sprite: {
      type: Array,
      default () {
        return [-1, -24, -48]
      }
    }
  },
  data () {
    return {
      isReady: false,
      isPlay: false,
      spriteIndex: 2,
      process: 100,
      time: ''
    }
  },
  computed: {
    position () {
      const index = this.spriteIndex % this.sprite.length
      return this.sprite[index]
    }
  },
  watch: {
    isPause (next, prev) {
      if (next && !prev) this.$refs.audio.pause()
    }
  },
  methods: {
    toggle () {
      const { paused } = this.$refs.audio
      if (paused) {
        this.$emit('start')
        if (this.process === 100) {
          this.process = 0
          setTimeout(() => {
            this.isPlay = true
            this.$refs.audio.play()
          }, 100)
        } else {
          this.$refs.audio.play()
        }
      } else {
        this.$refs.audio.pause()
      }
    },
    ready (e) {
      this.isReady = true
      const m = Math.floor(e.target.duration / 60)
      const s = Math.floor(e.target.duration % 60).toString().padStart(2, '0')
      this.time = `${m}:${s}`
      return this.isReady
    },
    start () {
      this.$refs.audio.play()
    },
    run (e) {
      const total = e.target.duration
      const now = e.target.currentTime
      this.process = (now / total) * 100
      let m = Math.floor(now / 60)
      let s = Math.floor(now % 60).toString().padStart(2, '0')
      this.time = `${m}:${s}`
      this.spriteIndex++
      if (now === total) {
        this.spriteIndex = 2
        this.isPlay = false
      }
    }
  },
  mounted () {
    this.$refs.audio.addEventListener('loadedmetadata', this.ready)
    this.$refs.audio.addEventListener('timeupdate', this.run)
  }
}
</script>

<style scoped lang="postcss">
@import "var.css";
.voice {
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--color6);
  border-radius: 25px;
  overflow: hidden;

  & .icon {
    position: relative;
    flex: none;
    width: 24px;
    height: 26px;
    z-index: 1;
    background: url("http://az.img.nutsbp.nutsb.com/007/image/nuts_dartcome/pc/inbox/cut_page/dc_signal_state.png") no-repeat;
    background-position: -48px 0;
  }

  & .timer {
    flex: 1;
    position: relative;
    text-align: right;
    color: rgba(255,255,255,1);
    font-weight: bold;
  }

  & .process {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--color1);

    &.play {
      transition: all 0.25s linear;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/voice/Voice.vue